import React, { Fragment } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button, Link } from 'formlabs-web-components/Link';

import './SingleDatasheet.module.css';

const SingleDatasheet = ({
  datasheet,
  linkDisplay,
  linkText,
  buttonColor,
  classes
}) => {
  return (
    <Fragment>
      {linkDisplay === 'text' && (
        <Link to={datasheet} classes={classes}>
          {linkText}
        </Link>
      )}
      {linkDisplay === 'button' && (
        <Button to={datasheet} color={buttonColor} classes={classes}>
          {linkText}
        </Button>
      )}
      {linkDisplay === 'icon-underline-arrow' && (
        <Link
          to={datasheet}
          styleName={'icon-underline-arrow'}
          classes={classes}
        >
          {linkText}
        </Link>
      )}
    </Fragment>
  );
};

export default DisplayComponent(SingleDatasheet);
